import {PredefinedControlId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function load(controlIds: PredefinedControlId[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/tprm/controls/load", {body: controlIds});
}

export async function updateTitle(controlId: PredefinedControlId, title: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/controls/{predefined_control_id}/title",
    {path: {predefined_control_id: controlId}, body: title},
  );
  await invalidateQueries([q.tprm.control.filter(controlId)]);
  return res;
}

export async function updateDescription(controlId: PredefinedControlId, description: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/controls/{predefined_control_id}/description",
    {path: {predefined_control_id: controlId}, body: description},
  );
  await invalidateQueries([q.tprm.control.filter(controlId)]);
  return res;
}

export async function reorder(controlId: PredefinedControlId, ordinal: number) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/controls/{predefined_control_id}/ordinal",
    {path: {predefined_control_id: controlId}, body: ordinal},
  );
  await invalidateQueries([q.tprm.frameworkProfile.filter()]);
  return res;
}
